/**
 * @file ShopCreatePage.tsx
 * @description «Платформа → Магазины → Новый магазин» (phase19.28 этап А,
 * v0.19.63; uiux-platform-shops §3; PL2, PL4–PL8).
 *
 * Страница, а не окно: полей много и после создания на месте формы
 * встаёт экран итога (`ShopCreatedChecklist`). На широком экране — колонка
 * 640px. Главное действие «Создать магазин» — в шапке, на телефоне
 * закреплено внизу (кнопка отправляет форму по `form=`). Право
 * `PLATFORM_MANAGE_SHOPS` проверяет маршрут.
 */

import { Store } from "lucide-react";

import { useShopCreateForm } from "../../../hooks/platform/useShopCreateForm";
import { ShopCreateMainFields } from "../../../components/platform/shops/ShopCreateMainFields";
import { ShopCreateSummary } from "../../../components/platform/shops/ShopCreateSummary";
import { ShopCreatedChecklist } from "../../../components/platform/shops/ShopCreatedChecklist";
import { ShopOwnerFields } from "../../../components/platform/shops/ShopOwnerFields";
import { Alert } from "../../../components/ui/alert";
import { Button } from "../../../components/ui/button";
import { CabinetPageHeader } from "../../../components/ui/CabinetPageHeader";

const FORM_ID = "shop-create-form";
const BACK = { to: "/platform/shops", label: "К магазинам" };

export function ShopCreatePage() {
  const form = useShopCreateForm();

  if (form.result) {
    return (
      <div className="flex w-full max-w-[640px] flex-col gap-6">
        <CabinetPageHeader title="Магазин создан" back={BACK} />
        <ShopCreatedChecklist result={form.result} ownerMode={form.ownerMode} onCreateMore={form.reset} />
      </div>
    );
  }

  return (
    <div className="flex w-full max-w-[640px] flex-col gap-6">
      <CabinetPageHeader
        title="Новый магазин"
        subtitle="Адрес на платформе, владелец и пустой закрытый сайт"
        back={BACK}
        action={
          <Button variant="brand" type="submit" form={FORM_ID} loading={form.submitting}>
            <Store className="size-4" aria-hidden />
            Создать магазин
          </Button>
        }
      />
      <form
        id={FORM_ID}
        noValidate
        className="flex flex-col gap-6"
        onSubmit={(event) => {
          event.preventDefault();
          void form.submit();
        }}
      >
        <ShopCreateMainFields
          value={form.value}
          onChange={form.setValue}
          errors={form.errors}
          timeZones={form.timeZones}
          slugCheck={form.slugCheck}
          disabled={form.submitting}
        />
        <ShopOwnerFields
          value={form.value}
          onChange={form.setValue}
          errors={form.errors}
          lookup={form.lookup}
          lookupUnavailable={form.lookupUnavailable}
          disabled={form.submitting}
        />
        {form.errors.form ? <Alert severity="error">{form.errors.form}</Alert> : null}
        <ShopCreateSummary slug={form.value.slug} invite={!form.lookup?.user} />
      </form>
    </div>
  );
}
